<template>
  <div>
<!--   
    <div class="wmd-view-topscroll">
      <div class="scroll-div1">
      </div>
    </div> -->

    <aw-table class="table-striped"
                  id="advertisementTable"
                  :fixed-body-header="true"
                  drag-scroll-dir="x"
                  :border="true"
                  :header-cell-style="tableRowStyle"
                  style="width: 100%; margin-bottom: 10px; font-size: 10px"
                  :data="list"
                  ref="advertisementTable"
                  @sort-change="handleSortChange"
                  @selection-change="handleSelectionChange"                  
                  
                  >
<!-- 
    <el-table v-if="isShowTable"
              id="advertisementTable"
              style="width: 100%; margin-bottom: 10px; font-size: 10px"
              :data="list"
              :header-cell-style="tableRowStyle"
              ref="advertisementTable"
              @sort-change="handleSortChange"
              @selection-change="handleSelectionChange"> -->
              
      <el-table-column
        fixed
        type="selection"
        label="기능"
        width="55">
      </el-table-column>
      <el-table-column
        fixed
        label="사진"
        v-if="isHiddenColumn('image')"
        width="150">
        <template slot-scope="props">
          <img v-bind:src="'/api/common/media/' + props.row.advertisement_seq" style="width: 150px"/>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="company_name"
        v-if="isHiddenColumn('company_name')"
        label="업체명"
        sortable
        width="95">
      </el-table-column>
      <el-table-column
        fixed
        label="상품명"
        prop="goods_name"
        v-if="isHiddenColumn('goods_name')"
        sortable
        width="100">
        <template slot-scope="props">
          <a v-if="pageType !== 'orderManagement'" href="javascript:void(0);" style="word-break: break-all;"
             @click="editRow(props.row)"> {{props.row.goods_name}}</a>
          <div
            v-if="pageType === 'orderManagement'">
            {{props.row.goods_name}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="license_number"
        label="사업자번호"
        v-if="isHiddenColumn('license_number')"
        sortable
        width="105">
      </el-table-column>
      <el-table-column
        fixed
        prop="store_name"
        v-if="isHiddenColumn('store_name') && this.pageType !== 'storeStatus'"
        sortable
        width="90"
        label="점포">
      </el-table-column>
      <!--      <el-table-column
              prop="media_type"
              v-if="isHiddenColumn('media_type')"
              sortable
              label="매체구분"
              width="95">
              <template slot-scope="props">
                {{ props.row.media_type === "WC" ? "와이드칼라" : "디지털미디어"}}
              </template>
            </el-table-column>-->
      <el-table-column
        fixed
        label="색상"
        v-if="isHiddenColumn('color')"
        width="75"
        align="center">
        <template slot-scope="props">
          <el-button :style="'background-color:' +  props.row.color" circle></el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="media_name"
        v-if="isHiddenColumn('media_name')"
        sortable
        width="95"
        label="광고매체">
      </el-table-column>
      <el-table-column
        prop="width"
        v-if="isHiddenColumn('width')"
        sortable
        label="넓이(mm)"
        width="95">
        <template slot-scope="props">
          {{ props.row.width | numeral('0,0')}}
        </template>
      </el-table-column>
      <el-table-column
        prop="height"
        v-if="isHiddenColumn('height')"
        sortable
        label="높이(mm)"
        width="95">
        <template slot-scope="props">
          {{ props.row.height | numeral('0,0')}}
        </template>
      </el-table-column>
      <el-table-column
        prop="profit_text"
        v-if="isHiddenColumn('profit')"
        sortable
        width="95"
        label="현황구분">
      </el-table-column>
      <el-table-column
        prop="in_out"
        v-if="isHiddenColumn('in_out')"
        sortable
        width="95"
        label="IN/OUT">
      </el-table-column>
      <el-table-column
        prop="is_light"
        v-if="isHiddenColumn('is_light')"
        sortable
        width="130"
        label="조명여부/송출시간">
        <template slot-scope="props">
          {{ props.row.media_type === "DM" ? props.row.duration : getIsLight(props.row.is_light) }}
        </template>
      </el-table-column>
      <!--<el-table-column
        prop="duration"
        v-if="isHiddenColumn('duration')"
        label="송출시간">
      </el-table-column>-->
      <el-table-column
        label="연광고료"
        prop="prepayment_price"
        v-if="isHiddenColumn('prepayment_price')"
        sortable
        width="95">
        <template slot-scope="props">
          {{ props.row.prepayment_price === 0 ? "-" : numberWithCommas(props.row.prepayment_price.toString()) + "원"}}
        </template>
      </el-table-column>
      <el-table-column
        label="월광고료"
        prop="installment_price"
        v-if="isHiddenColumn('installment_price')"
        sortable
        width="95">
        <template slot-scope="props">
          {{ props.row.installment_price === 0 ? "-" : numberWithCommas(props.row.installment_price.toString()) + "원"}}
        </template>
      </el-table-column>
      <el-table-column
        prop="billing_type"
        v-if="isHiddenColumn('billing_type')"
        width="90"
        sortable
        label="정산방식">
        <template slot-scope="props">
          {{ getBillingType(props.row.billing_type)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="month"
        v-if="isHiddenColumn('month')"
        width="90"
        sortable
        label="개월수">
        <template slot-scope="props">
          {{ props.row.billing_type === "D" ? props.row.month + " 개월" : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="isHiddenColumn('floor')"
        prop="floor"
        sortable
        width="70"
        label="층">
        <template slot-scope="props">
          {{ props.row.floor_type === 'F' ? props.row.floor + props.row.floor_type : props.row.floor_type +
          props.row.floor}}
        </template>
      </el-table-column>
      <el-table-column
        prop="position_number"
        v-if="isHiddenColumn('position_number')"
        sortable
        width="100"
        label="위치">
        <template slot-scope="props">
          {{ props.row.position_number + props.row.position_code}}
        </template>
      </el-table-column>
      <el-table-column
        prop="team"
        v-if="isHiddenColumn('team')"
        sortable
        label="팀">
      </el-table-column>
      <el-table-column
        prop="category"
        v-if="isHiddenColumn('category')"
        sortable
        label="대분류">
      </el-table-column>
      <el-table-column
        prop="replacement_date"
        v-if="isHiddenColumn('replacement_date')"
        width="120"
        sortable
        label="최근교체일">
      </el-table-column>
      <el-table-column
        prop="etc"
        v-if="isHiddenColumn('etc')"
        width="90"
        sortable
        label="부킹여부">
      </el-table-column>
      <el-table-column
        prop="draft_name"
        v-if="isHiddenColumn('draft_name')"
        width="90"
        sortable
        label="교체시안">
      </el-table-column>
      <el-table-column
        prop="position_info"
        v-if="isHiddenColumn('position_info')"
        width="90"
        sortable
        label="위치안내">
      </el-table-column>


    <!-- </el-table> -->
    </aw-table>
    <el-col :span="24" v-if="pageType === 'advertisement'">
      <p-pagination class="pull-right"
                    v-on:input="changePage"
                    v-model="pagination.currentPage"
                    :per-page="perPage"
                    :total="pagination.totalCnt">
      </p-pagination>
    </el-col>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn} from 'element-ui'
  import ColumnSettingProxy from "@/proxies/ColumnSettingProxy";
  import StoreProxy from "@/proxies/StoreProxy";
  import OrderProxy from "@/proxies/OrderProxy";
  import AdvertiserProxy from "@/proxies/AdvertiserProxy";
  import VueMoment from 'vue-moment'
  import vueNumeralFilterInstaller from 'vue-numeral-filter';
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import AwTable from '@/components/UIComponents/Table/AwTable.vue'

  Vue.use(vueNumeralFilterInstaller)
  Vue.use(VueMoment)
  Vue.use(Table)
  Vue.use(TableColumn)

  export default {
    name: "AdvertisementListComponent",
    components: {
      PPagination,
      AwTable
    },
    created: function () {
      this.findAllByUserIdAndPageType(this.pageType);
      if (this.pageType === "orderManagement") {
        this.getOrderList();
      }
    },
    props: {
      pageType: String,
      perPage: Number,
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderFont10CellStyle;
      },
      // 항목 선택
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.setMultipleSelection();
      },
      // 정렬 변경
      handleSortChange({column, prop, order}) {
        this.sort = {sortColumn: prop, sortOrder: order};
        if (this.pageType === "advertisement") {
          this.param.sortColumn = prop;
          this.param.sortOrder = order;
          this.getAdvertiserMediaList(this.param);
        }
      },
      // 컬럼 숨기기
      isHiddenColumn(column) {
        return this.columns.filter(function (c) {
          return c.id === column && c.show;
        }).length > 0;
      },
      // 광고 리스트 조회
      getList(param) {
        // 상세화면에서 돌아올때 리스트를 다시 검색하는 함 (검색 파라메타를 기억하고 있다고 재사용)
        if (param !== null) {
          this.param = param;
        }
        if (this.param !== null) {
          if (this.pageType === "storeStatus") {
            this.getStoreMediaList(this.param);
          } else if (this.pageType === "orderManagement") {
            this.getOrderList(this.param);
          } else if (this.pageType === "advertisement") {
            this.$store.dispatch('advertiser/initMultipleSelection');
            this.resetList();
            this.getAdvertiserMediaList(this.param);
          }
        }
      },
      // 점포관리 > 점포현황 조회
      getStoreMediaList(param) {
        new StoreProxy(param)
          .getStoreMediaList(param.storeSeq, param.storeFloorSeq)
          .then((response) => {
            this.list = response.medias;
            this.setTopScroll();
          });
      },
      // 발주관리 조회
      getOrderList(param) {
        new OrderProxy()
          .all()
          .then((response) => {
            this.list = response.orders;
            this.setTopScroll();
          });
      },
      // 광고주 > 전체현황 조회
      getAdvertiserMediaList(param) {
        new AdvertiserProxy()
          .getAdvertiserMediaList(param)
          .then((response) => {
            this.list = response.medias;
            this.pagination.totalCnt = response.totalCnt;
            this.setTopScroll();
            this.reselectMultipleSelection();
          });
      },
      // 페이지 변경
      changePage(item) {
        this.param.page = item;
        this.param.rows = this.perPage;
        this.getAdvertiserMediaList(this.param);
        this.page = item;
      },
      // 선택항목 저장소에 저장
      setMultipleSelection() {
        if (this.multipleSelection.length > 0 && this.pageType === "advertisement") {
          this.$store.dispatch('advertiser/setMultipleSelection', {
            page: this.page - 1,
            multipleSelection: this.multipleSelection
          });
        }
      },
      // 선택항목을 저장소에서 가져와서 다시 설정
      reselectMultipleSelection() {
        if (this.pageType === "advertisement") {
          setTimeout(() => {
            if (this.$store.state.advertiser.multipleSelection[this.pagination.currentPage - 1] !== undefined) {
              this.$store.state.advertiser.multipleSelection[this.pagination.currentPage - 1].forEach(row => {
                let advertisements = this.list.filter(function (f) {
                  return f.advertisement_seq === this.advertisement_seq
                }, {advertisement_seq: row.advertisement_seq});
                if (advertisements.length > 0) {
                  this.$refs.advertisementTable.toggleRowSelection(advertisements[0]);
                }
              });
            }
          }, 500);
        }
      },
      // 컬럼설정 조회
      findAllByUserIdAndPageType(pageType) {
        this.isShowTable = false;
        new ColumnSettingProxy()
          .findAllByUserIdAndPageType(pageType)
          .then((response) => {
            this.columns = response.columnSettings;
            this.isShowTable = true;
            this.setTopScroll();
            this.reselectMultipleSelection();
          })
      },
      // 광고 수정
      editRow(row) {
        this.$emit('detailRow', row);
      },
      // 광고 상세 조회
      detailRow(row) {
        this.$emit('detailRow', row);
      },
      // 선택항고 조회
      getMultipleSelections() {
        return this.multipleSelection;
      },
      // 리스트 초기화
      resetList() {
        this.page = 1;
        this.list = [];
        this.pagination.perPage = 10;
        this.pagination.currentPage = 1;
        this.pagination.totalCnt = 0;
      },
      // 정령 방식 조회
      getSort() {
        return this.sort;
      },
      // 상단 스크롤 생성
      setTopScroll() {
        $(function () {
          $(".scroll-div1").width($("#advertisementTable .el-table__body").width());
          $(".wmd-view-topscroll").scroll(function () {
            $(".el-table--scrollable-x .el-table__body-wrapper").scrollLeft($(".wmd-view-topscroll").scrollLeft());
          });
          $(".el-table--scrollable-x .el-table__body-wrapper").scroll(function () {
            $(".wmd-view-topscroll").scrollLeft($(".el-table--scrollable-x .el-table__body-wrapper").scrollLeft());
          });
        });
      },
      getBillingType(billing_type) {
        return Vue.getBillingType(billing_type);
      },
      getIsLight(isLight) {
        return Vue.getIsLight(isLight);
      },
      numberWithCommas(x) {
        return Vue.NumberWithCommas(x);
      },
      getListSize() {
        return this.list.length;
      },
    },
    data() {
      return {
        columns: [],
        multipleSelection: [],
        list: [],
        isShowTable: true,
        param: null,
        sort: {
          sortColumn: '',
          sortOrder: '',
        },
        page: 1,
        pagination: {
          totalCnt: 0,
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
        },
      }
    },
  }
</script>

<style scoped>
  .wmd-view-topscroll {
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    border: none 0px RED;
  }

  .wmd-view-topscroll {
    height: 20px;
  }

  .scroll-div1 {
    width: 1880px;
    overflow-x: scroll;
    overflow-y: hidden;
    height: 20px;
  }

</style>
<style>
  .table > thead > tr > th, .el-table table > thead > tr > th, .table > tbody > tr > th, .el-table table > tbody > tr > th, .table > tfoot > tr > th, .el-table table > tfoot > tr > th, .table > thead > tr > td, .el-table table > thead > tr > td, .table > tbody > tr > td, .el-table table > tbody > tr > td, .table > tfoot > tr > td, .el-table table > tfoot > tr > td {
    padding: 12px 0px !important;
    vertical-align: middle !important;
  }
</style>
